import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'

import config from '@/config'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

Vue.use(Vuex)
Vue.use(VueLocalStorage)

export const store = new Vuex.Store({
  state: {
    loading : false,
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') == "true",
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot: JSON.parse(Vue.localStorage.get('selectedBot')),
    userid: Vue.localStorage.get('userid'),
    botlist: JSON.parse(Vue.localStorage.get('botlist')),
    pagelist: JSON.parse(Vue.localStorage.get('pagelist')),
    accessToken:  Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    }
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js